import { Component } from '@angular/core';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-scorp-cgv',
  templateUrl: './scorp-cgv.component.html',
  styleUrls: ['./scorp-cgv.component.scss'],
  standalone: false,
})
export class ScorpCgvComponent {
  language$ = this.accountRepo.language$;

  constructor(private accountRepo: AccountRepository) {}
}
